import {
  MOUNT,
  UNMOUNT,
  UPDATE_SELECTED_FASTTRACK_PROJECT,
  POST_FASTTRACK,
  POST_FASTTRACK_SUCCESS,
  POST_FASTTRACK_START,
  POST_FASTTRACK_ERROR
} from './constants'
import {
  buildAsyncAction
} from 'containers/Async/actions'

const mount = () => ({ type: MOUNT })
const unmount = () => ({ type: UNMOUNT })

const updateSelectedFastTrackProject = (projectId) => ({ type: UPDATE_SELECTED_FASTTRACK_PROJECT, projectId})

const postFastTrack = (projectId, sourceProjectId) => ({ type: POST_FASTTRACK, projectId, sourceProjectId})

const postFastTrackStart = () => ({ type: POST_FASTTRACK_START })
const postFastTrackSuccess = () => ({ type: POST_FASTTRACK_SUCCESS })
const postFastTrackError = (error) => ({ type: POST_FASTTRACK_ERROR, error })
const startpostFastTrackAsync = buildAsyncAction(
  POST_FASTTRACK,
  POST_FASTTRACK_START,
  [POST_FASTTRACK_SUCCESS, POST_FASTTRACK_ERROR]
)

export {
  mount,
  unmount,
  updateSelectedFastTrackProject,
  postFastTrack,
  postFastTrackStart,
  postFastTrackSuccess,
  postFastTrackError,
  startpostFastTrackAsync
}
